import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { currentInstallerHammerRatingCount, ExtendedHammerRatingDetails } from '../../../../core/installer-profile';

@Component({
  selector: 'gc-installer-vti-details',
  templateUrl: './installer-vti-details.component.html',
  styleUrls: ['./installer-vti-details.component.scss'],
})
export class InstallerVtiDetailsComponent {
  @Input() hammerRatingsDetails!: ExtendedHammerRatingDetails[];

  hammerRatingCount$ = this.store.select(currentInstallerHammerRatingCount);

  constructor(private readonly store: Store) {}

  getDialImgPathByRating(rating: number): string {
    if (rating < 0.625) { return 'assets/images/VTI-imgs/VTI Dial-Rookie.png'; }
    if (rating < 1.25) { return 'assets/images/VTI-imgs/VTI Dial-Intermediate.png'; }
    if (rating < 1.875) { return 'assets/images/VTI-imgs/VTI Dial-Experienced.png'; }
    if (rating < 2.5) { return 'assets/images/VTI-imgs/VTI Dial-Proficient.png'; }
    if (rating < 3.125) { return 'assets/images/VTI-imgs/VTI Dial-Expert.png'; }
    if (rating < 3.75) { return 'assets/images/VTI-imgs/VTI Dial-Master.png'; }
    if (rating < 4.375) { return 'assets/images/VTI-imgs/VTI Dial-Artisan.png'; }
    return 'assets/images/VTI-imgs/VTI Dial-Elite Artisan.png';
  }
}
